import React from 'react';
import { TimeoffForm } from './timeoff-form';
import { TimeoffHistory } from './timeoff-history';
import { TimeoffDrawerType } from './timeoff-setting';
import { TimeOffDrawerStyled } from './timeoff.styles';

interface TimeoffDrawerProps {
  handleClose: () => void;
  drawerType: TimeoffDrawerType;
}

export const TimeoffDrawer: React.FC<TimeoffDrawerProps> = ({
  handleClose,
  drawerType,
}) => {
  return (
    <TimeOffDrawerStyled
      width={drawerType === 'TIMEOFF_FORM' ? '360px' : '600px'}
      onClose={() => handleClose()}
      visible={drawerType !== null}
    >
      {drawerType === 'TIMEOFF_FORM' ? (
        <TimeoffForm handleClose={handleClose} />
      ) : drawerType === 'TIMEOFF_HISTORY' ? (
        <TimeoffHistory handleClose={handleClose} />
      ) : null}
    </TimeOffDrawerStyled>
  );
};
